import api from "./api";
import API_URLS from "../../constants/api-urls";

export default class RumTypeApi {
  createRumType(payload) {
    return api.post(API_URLS.URL.rumtypesampling.createRumType, payload);
  }

  updateRumType(id, payload) {
    return api.put(
      API_URLS.URL.rumtypesampling.updateRumType?.replace(
        ":id",
        id,
      ),
      payload
    );
  }

  getRumTypeList(payload) {
    return api.post(API_URLS.URL.rumtypesampling.getRumTypeList, payload);
  }

  deleteRumType(id) {
    return api.delete(
      API_URLS.URL.rumtypesampling.deleteRumType?.replace(
        ":id",
        id,
      )
    );
  }
}
